export default __webpack_public_path__ + "static/media/blob.4ee855ef.svg";